export default __webpack_public_path__ + "static/media/manifesto.6cbf938e.png";